import {
  lineConfigToChartItem,
  soiToScatterConfig,
  soiToTreeMapConfig,
  sopToScatterConfig,
  sopToTreeMapConfig,
} from '../../../helper-functions';
import type {
  IScatterChartTab,
  IChartTab,
  IResponseTypeLineItem,
  ISoiScatterItem,
  ISopScatterItem,
  IOnlyMyBrandsMap,
} from '../../../types';
import { ChartsTypeEnum } from '../../../types';

export default (
  tabs: IScatterChartTab[] | IChartTab[],
  data: IResponseTypeLineItem['data'],
  activeTabCard: number,
  activeTabDate: number,
  type: ChartsTypeEnum,
  onlyMyBrandsMap: IOnlyMyBrandsMap | null,
  activeBrands?: string[]
) => {
  if (!tabs) return [];

  switch (type) {
    case ChartsTypeEnum.line: {
      if (!data?.[activeTabDate]) return [];
      const currentData = data[activeTabDate];
      if (!currentData?.data) return [];

      const chartItems = currentData.data.map((item) =>
        lineConfigToChartItem(item, tabs[activeTabCard]?.key as string)
      );

      if (!onlyMyBrandsMap)
        return chartItems.filter(
          ({ brand }) => activeBrands?.includes?.(brand) || !activeBrands
        );

      return chartItems.filter(({ brand }) => onlyMyBrandsMap?.[brand]);
    }
    case ChartsTypeEnum.barStack: {
      if (!data?.[activeTabDate]) return [];
      const currentData = data[activeTabDate];
      if (!currentData?.data) return [];

      const chartItems = currentData.data.map((item) =>
        lineConfigToChartItem(item, tabs[activeTabCard]?.key as string)
      );

      if (!onlyMyBrandsMap)
        return chartItems.filter(
          ({ brand }) => activeBrands?.includes?.(brand) || !activeBrands
        );

      return chartItems.filter(({ brand }) => onlyMyBrandsMap?.[brand]);
    }
    case ChartsTypeEnum.scatter: {
      const map = {
        SoI: soiToScatterConfig,
        SoP: sopToScatterConfig,
      };
      const currentTab = tabs[activeTabCard] as IScatterChartTab;

      const currentTabData = currentTab.data.map((tab) =>
        map[currentTab.key as keyof typeof map](
          tab as ISoiScatterItem & ISopScatterItem
        )
      );

      if (!onlyMyBrandsMap) {
        return currentTabData.filter(
          ({ name }) => activeBrands?.includes?.(name) || !activeBrands
        );
      }

      return currentTabData.filter(({ name }) => onlyMyBrandsMap?.[name]);
    }
    case ChartsTypeEnum.treeMap: {
      const map = {
        SoI: soiToTreeMapConfig,
        SoP: sopToTreeMapConfig,
      };
      const currentTab = tabs[activeTabCard] as IScatterChartTab;

      const currentTabData = currentTab.data.map((tab) =>
        map[currentTab.key as keyof typeof map](
          tab as ISoiScatterItem & ISopScatterItem
        )
      );

      if (!onlyMyBrandsMap) {
        return currentTabData.filter(
          ({ name }) => activeBrands?.includes?.(name) || !activeBrands
        );
      }
      return currentTabData.filter(({ name }) => onlyMyBrandsMap?.[name]);
    }
    default: {
      return [];
    }
  }
};
